import React from 'react'
import image from './unnamed.png'
import './MainLoader.css';

const MainLoader = () => {
    return (
        <div>
            <div className="loading-screen">
                <div className="loading-animation">
                    <img
                        src={image}
                        alt="logo"
                        className="logoo"
                    />
                    <div className="loading-bar"></div>
                </div>
            </div>
        </div>
    )
}

export default MainLoader